import * as THREE from 'three';
import Experience from './Experience.js';
import PosterBackground from './scene/PosterBackground.js';
import LiveFeed from './scene/LiveFeed.js';
import Photo from './scene/Photo.js';
import NameText from './scene/NameText.js';

export default class World {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;

    this.posterAspectRatio = 191/270;

    this.resources = this.experience.resources;

    // Wait for resources
    this.resources.on('ready', () => {
      this.posterBackground = new PosterBackground();
      this.liveFeed = new LiveFeed();
      this.photo = new Photo();
      this.nameText = new NameText();

      this.initPlanes()
    });
  }

  initPlanes() {
    this.posterBackground.init();
    this.liveFeed.init();
    this.photo.init();
  }

  onScreenshotTaken(renderTargetTexture) {
    this.photo.material.uniforms.tWebcamPhoto.value = renderTargetTexture
    this.photo.mesh.visible = true    
    this.liveFeed.mesh.visible = false
  }

  onPreparePoster(posterName) {
    this.posterBackground.mesh.visible = true
    this.nameText.init(posterName);
    this.photo.mesh.scale.x = 0.568 * (1/this.posterAspectRatio)
    this.photo.mesh.scale.y = 0.568 * (9/16)
    this.photo.mesh.position.z = 0.91
    this.photo.mesh.position.y = -0.86;
    this.photo.mesh.position.x = 0.01;
  }

  onRetakePhoto() {
    this.photo.mesh.visible = false
    this.liveFeed.mesh.visible = true
  }


}